import { useState, useEffect } from 'react';
import { CalendarDays, Plus, RefreshCw } from '../icons/wp-icons';
import { Navigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import AbwesenheitMeine from '../components/Abwesenheit/AbwesenheitMeine';
import AbwesenheitFormular from '../components/Abwesenheit/AbwesenheitFormular';
import Modal from '../components/Common/Modal';
import { useAuth } from '../context/AuthContext';

// Diese Seite ist für Mitarbeiter (nicht-Admins)
// Admins nutzen die integrierte Ansicht unter /mitarbeiter
function Abwesenheiten() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();

  // Admins werden zur Mitarbeiter-Seite umgeleitet
  if (user?.rolle === 'admin') {
    return <Navigate to="/mitarbeiter?tab=uebersicht" replace />;
  }

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [editingAbwesenheit, setEditingAbwesenheit] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleCreate = () => {
    setEditingAbwesenheit(null);
    setIsFormModalOpen(true);
  };

  const handleEdit = (abwesenheit) => {
    setEditingAbwesenheit(abwesenheit);
    setIsFormModalOpen(true);
  };

  const handleFormClose = () => {
    setIsFormModalOpen(false);
    setEditingAbwesenheit(null);
  };

  const handleFormSuccess = () => {
    setIsFormModalOpen(false);
    setEditingAbwesenheit(null);
    handleRefresh();
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 overflow-x-hidden">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 sm:mb-8">
          <div>
            <div className="flex items-center gap-3">
              <CalendarDays className="w-7 h-7 sm:w-8 sm:h-8 text-primary" />
              <h1 className="text-2xl sm:text-3xl font-serif font-bold text-gray-900">Meine Abwesenheiten</h1>
            </div>
            <p className="text-gray-600 text-sm sm:text-base mt-1">
              Urlaub beantragen und Abwesenheiten verwalten
            </p>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={handleRefresh}
              className="p-2 hover:bg-gray-100 rounded-lg transition"
              title="Aktualisieren"
            >
              <RefreshCw className="w-5 h-5 text-gray-500" />
            </button>
            <button
              onClick={handleCreate}
              className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-button font-medium hover:bg-primary-dark transition"
            >
              <Plus className="w-5 h-5" />
              <span className="hidden sm:inline">Abwesenheit beantragen</span>
              <span className="sm:hidden">Neu</span>
            </button>
          </div>
        </div>

        {/* Content */}
        <AbwesenheitMeine
          key={`meine-${refreshKey}`}
          onEdit={handleEdit}
          onRefresh={handleRefresh}
        />
      </div>

      {/* Formular Modal */}
      <Modal
        isOpen={isFormModalOpen}
        onClose={handleFormClose}
        title={editingAbwesenheit ? 'Abwesenheit bearbeiten' : 'Abwesenheit beantragen'}
      >
        <AbwesenheitFormular
          abwesenheit={editingAbwesenheit}
          onSuccess={handleFormSuccess}
          onCancel={handleFormClose}
        />
      </Modal>
    </Layout>
  );
}

export default Abwesenheiten;
